import { Text, type TextProps } from '@chakra-ui/react';

export const ProductDisclaimer = ({ children, ...props }: TextProps) => (
  <Text size="detail" color="blackAlpha.700" {...props}>
    {children}
  </Text>
);
